import React, { useState, useEffect } from 'react';
import { versionService, BackendVersionInfo } from '../api/versionService';
import { BUILD_INFO } from '../buildInfo';

const uiVersion = BUILD_INFO.version;

export function VersionFooter() {
  const [info, setInfo] = useState<BackendVersionInfo | null>(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    versionService.getVersionInfo().then(setInfo);
  }, []);

  return (
    <footer className="version-footer">
      <button
        className="version-footer-toggle"
        onClick={() => setExpanded(e => !e)}
        title="Versionsinformationen"
      >
        UI v{uiVersion}
        {info && <> · API v{info.api}</>}
        <span className="version-footer-arrow">{expanded ? '▲' : '▼'}</span>
      </button>

      {expanded && (
        <div className="version-footer-details">
          <table className="version-table">
            <tbody>
              <tr><td>UI (React)</td><td>v{uiVersion} · {BUILD_INFO.gitSha} · {BUILD_INFO.buildDate}</td></tr>
              {info && <>
                <tr><td>API</td><td>v{info.api}{(info as any).gitSha ? ` · ${(info as any).gitSha}` : ''}</td></tr>
                <tr><td>BL</td><td>v{info.bl}</td></tr>
                <tr><td>DL</td><td>v{info.dl}</td></tr>
                <tr><td>SEPA</td><td>v{info.sepa}</td></tr>
                <tr><td>Umgebung</td><td>{info.environment}</td></tr>
                <tr><td>Serverzeit</td><td>{new Date(info.serverTime).toLocaleString('de-DE')}</td></tr>
              </>}
            </tbody>
          </table>
        </div>
      )}
    </footer>
  );
}
